module.exports = __webpack_public_path__ + "img/horizontal_3_3_7005.3e889c32.png";